import { SerializedConstructor } from '@langchain/core/load/serializable';

import { PROMPT_EXCLUDED_VARIABLES } from '../constants';

export function getUpdatedMappingFromManifest(
  manifest: SerializedConstructor,
  currentVariableMapping: Record<string, string>
) {
  const inputVars = manifest.kwargs.input_variables;

  // Check if current mapping keys match input variables
  const currentKeys = Object.keys(currentVariableMapping).sort();
  const inputVarsKeys = [...inputVars].sort();
  const mappingsMatch =
    currentKeys.length === inputVarsKeys.length &&
    currentKeys.every((key, i) => key === inputVarsKeys[i]);

  const hasIncompleteVariable = inputVars.some(
    (variable) => variable.includes('{{') || variable.includes('}}')
  );
  if (!mappingsMatch && !hasIncompleteVariable) {
    const variableMapping = inputVars.reduce((acc, variable) => {
      // Only set mapping if it doesn't already exist
      if (
        !currentVariableMapping[variable] &&
        !PROMPT_EXCLUDED_VARIABLES.includes(variable)
      ) {
        acc[variable] = undefined;
      } else {
        acc[variable] = currentVariableMapping[variable];
      }
      return acc;
    }, {} as Record<string, string>);
    return variableMapping;
  }

  return currentVariableMapping;
}
